module.exports = __webpack_public_path__ + "img/Picture14.e2209c07.png";